import type { TFunction } from 'i18next';
import type { NotificationTestOutcome } from './api.ts';
import { needsHomeScreen } from './push.ts';

/**
 * Cosa dire dopo una prova di notifica, e cosa fare.
 *
 * Sta qui e non dentro una schermata perché il pulsante "Prova notifica" è in
 * due posti: nella console, dove si vede al primo turno (sezione 5.7), e nella
 * schermata delle notifiche. Gli esiti sono gli stessi e il rimedio anche —
 * ripeterlo in due punti significherebbe correggerne uno solo.
 *
 * Tre esiti, tre cause diverse: nessun dispositivo iscritto, il servizio push
 * che non risponde, le chiavi che mancano sul server. "Non ha funzionato"
 * lascerebbe una persona al primo turno a indovinare quale dei tre.
 */
export function testMessage(
  outcome: NotificationTestOutcome,
  t: TFunction,
): [string, string | undefined] {
  switch (outcome) {
    case 'delivered':
      return [t('notifications.test_sent'), undefined];
    case 'no_subscription':
      return [
        t('notifications.test_no_subscription'),
        needsHomeScreen() ? t('notifications.ios_hint') : undefined,
      ];
    case 'not_configured':
      return [t('notifications.push_not_configured'), t('notifications.safety_net')];
    default:
      return [t('notifications.test_failed'), t('notifications.safety_net')];
  }
}
